"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    cdfPayUserPortalUrl: 'https://user.cdfpay.flexischools.com.au/',
    supplierPortalUrl: 'https://supplier.flexischools.com.au',
    supplierPortalV4Url: 'http://localhost:4000',
    opsPortalUrl: 'https://ops.flexischools.com.au',
    ssspUrl: 'https://www.flexischools.com.au/SupplierPortal',
    supplierAdminBaseUrl: 'https://admin.fleximeals.com.au/SupplierPortal',
    flexischoolsApiBaseUrl: 'https://www.flexischools.com.au/FM_Services/',
    adminApiBaseUrl: 'https://admin.fleximeals.com.au/FM_Services/',
    legacyOrdringSite: 'https://www.flexischools.com.au/FM/m/Home/Legacy',
    legacyBaseUrl: 'https://flexischools.com.au/',
    flexibuzzWebBaseUrl: 'https://buzz.flexischools.com.au/',
    flexibuzzNewsFeedId: 1393,
    flxBusinessIdInBuzz: 11047,
    userApiBaseUrl: 'https://api.user.flexischools.com.au/',
    bffBaseUrl: 'https://servicebff.flexischools.com.au/api/v1.0/graphql/',
    bffHealthcheckBaseUrl: 'https://servicebff.flexischools.com.au/',
    bffCommsBaseUrl: 'https://bffcomms.flexischools.com.au/api/v1.0/',
    signalRBaseUrl: 'https://clientnotifications.flexischools.com.au/signalrhub/notifications',
    firebase: {
        apiKey: 'AIzaSyC_ezVz8fR7QeLTNdLjlwLtmSKQjCpbkPI',
        authDomain: 'flexischools-app.firebaseapp.com',
        databaseURL: 'https://flexischools-app.firebaseio.com',
        projectId: 'flexischools-app',
        storageBucket: 'flexischools-app.appspot.com',
        messagingSenderId: '1018976376951',
        appId: '1:1018976376951:web:59fa6dec23d51465f00e72',
        measurementId: 'G-NT8ME4CPLN',
    },
    launchDarklyClientId: '6195d4c05b2be8144fea36a1',
    launchDarklyDefaultUser: 'f80c1350-b1e8-4778-852a-64171d6727a3',
    openInAppLink: 'https://flexischools.page.link/uy1b',
    orderingBffBaseUrl: 'https://bffordering.flexischools.com.au/api/v1.0/',
    supplierBffBaseUrl: 'https://bffsupplier.flexischools.com.au/api/v1.0/',
    supplierBffV2BaseUrl: 'https://bffsupplier.flexischools.com.au/api/v2.0/',
    opsBffBaseUrl: 'https://bffops.flexischools.com.au/api/v1.0/',
    TimeRegionKeyEnum: {
        Sydney: '8551E954-0C4E-4E71-B539-DA06E47B91B1',
        Melbourne: '8551E954-0C4E-4E71-B539-DA06E47B91B1',
        Canberra: '8551E954-0C4E-4E71-B539-DA06E47B91B1',
        Hobart: '8551E954-0C4E-4E71-B539-DA06E47B91B1',
        Brisbane: 'A798D4A9-9132-4BDA-83FF-7A7CD79BD200',
        Adelaide: 'CF8C933E-A138-472C-A14B-A2294AF40CA6',
        Perth: '3E91EAA7-D51F-4340-B3E9-9F89F4DA2EFF',
        UTC: '445074E4-4053-4EBE-94BD-F122894C6192',
        Darwin: 'A23C6E2C-3BA7-4477-BB23-B74CEB0D2836',
    },
    GtmKey: 'GTM-PKHSCSHM',
    paypalClientId: 'Ab10K1nWHRAzQrAnJd3ibvZ_o7C8v5jdV5SqlwMQo3MKNh-c6AdUoAzCYswaFjGdYeBxlAeYoDZo3liD',
    env: 'PROD',
};
//# sourceMappingURL=AppConfig.js.map